<template>
    <div class="app-container">
      <div class="background-text">Renox AI</div>
      <atom-spinner :animation-duration="1000" :size="700" color="#ff1d5e" />
    </div>
   <!-- - - [ Please Wait ] - - -->
  </template>
  
  <script>
  import { AtomSpinner } from 'epic-spinners';
  
  export default {
    components: {
      AtomSpinner,
    },
  };
  </script>
  
  <style scoped>
  .app-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 10vh; /* Full viewport height */
    position: relative; /* For absolute positioning of overlay */
  }
  
  .background-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); /* Center the text */
    font-size: 6em; /* Adjust as needed */
    color: rgba(10, 10, 10, 0.7); /* Semi-transparent white text */
    z-index: 1; /* Make sure text is below spinner */
    text-align: center; /* Center align text */
  }
  
  .atom-spinner {
    z-index: 2; /* Make sure spinner is above text */
  }
  </style>
  